import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { IShowing, IFilterParams } from '../../../models/showing';
import { formatDateTime } from '../../../utils/format.time';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ShowingsListDelegate')
export class ShowingsListDelegate extends DataDelegate {

    private _totalItems: number = 100;
    get TotalItems(): number {
        return this._totalItems;
    }
    set TotalItems(num: number) {
        this._totalItems = num;
    }

    private _currentPage: number = 100;
    get CurrentPage(): number {
        return this._currentPage;
    }
    set CurrentPage(num: number) {
        this._currentPage = num;
    }

    private _filterParams: IFilterParams = {
        address: '',
        listingAgent: '',
        showingAgent: '',
        status: [
            'Unconfirmed',
            'Confirmed',
            'Cancelled',
            'FeedbackPending'
        ]
    };
    get FilterParams(): IFilterParams {
        return this._filterParams;
    }
    set FilterParams(filter: IFilterParams) {
        this._filterParams = filter;
    }

    constructor() {
        super('ShowingsListDelegate');
    }

    public async searchShowings(page = 1, pageSize = 10) {
        // await T_T.delay(2000);
        // const dataSource = new DummyDataDelegate();
        // this.Data = await dataSource.searchDataAPI(address, listingAgent, showingAgent, status);
        const params = this.FilterParams;
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        let uri = `${apiHost}/showing/pagination?pageSize=${pageSize}&pageNo=${page}`;
        if (T_T.simpleDetect(params.address) && params.address !== '') {
            uri += `&addr=${params.address}`;
        }
        if (T_T.simpleDetect(params.listingAgent) && params.listingAgent !== '') {
            uri += `&listingAgent=${params.listingAgent}`;
        }
        if (T_T.simpleDetect(params.showingAgent) && params.showingAgent !== '') {
            uri += `&showingAgent=${params.showingAgent}`;
        }
        if (T_T.simpleDetect(params.status) && params.status !== []) {
            uri += `&statusList=${params.status.join(',')}`;
        }
        const fetched = await AxiosPromise.get(uri);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            this.TotalItems = fetched.data.total;
            this.CurrentPage = page;
            const data: IShowing[] = fetched.data.list.map((v: any) => this.showingMapper(v));
            this.Data = data;
            return 1;
        } else {
            return 0;
        }
    }

    private showingMapper(data: any): IShowing {
        const showing: IShowing = {
            status: T_T.simpleDetect(data.xStatus) ? data.xStatus : '',
            id: T_T.simpleDetect(data.id) ? data.id : '',
            listing_id: T_T.simpleDetect(data.xRadarListingsId) ? data.xRadarListingsId : '',
            visit_date: T_T.simpleDetect(data.xShowingDate) ? formatDateTime(data.xShowingDate) : '',
            created_date: T_T.simpleDetect(data.createDate) ? formatDateTime(data.createDate) : '',
            address: T_T.simpleDetect(data.xAddress) ? data.xAddress : '',
            listing_agent_one: this.listingAgentOneMapper(data),
            listing_agent_two: this.listingAgentTwoMapper(data),
            showing_agent: T_T.simpleDetect(data.showingAgent) ? data.showingAgent.name : ''
        };
        return showing;
    }

    public listingAgentOneMapper(data: any) {
        if (T_T.simpleDetect(data.radarListings)) {
            if (T_T.simpleDetect(data.radarListings.agentList)) {
                if (data.radarListings.agentList.length > 0) {
                    if (T_T.simpleDetect(data.radarListings.agentList[0].name)) {
                        return data.radarListings.agentList[0].name;
                    }
                }
            }
        }
        return '';
    }

    public listingAgentTwoMapper(data: any) {
        if (T_T.simpleDetect(data.radarListings)) {
            if (T_T.simpleDetect(data.radarListings.agentList)) {
                if (data.radarListings.agentList.length > 1) {
                    if (T_T.simpleDetect(data.radarListings.agentList[1].name)) {
                        return data.radarListings.agentList[1].name;
                    }
                }
            }
        }
        return '';
    }
}
